import PlacesTable from "@/app/app-shared/places/table";

export default function PlacesListingPage() {
  return (
    <div className="mt-4">
      <PlacesTable />
    </div>
  );
}
